import React, {Component} from 'react';
import {connect} from 'react-redux';
import Translator from '../../helpers/Translator';
import {DOMAIN} from '../FlightsContainer';
import FlightDetails from './FlightDetails';
import DateTimeFormatter from '../../helpers/DateTimeFormatter';
import PriceFormatter from '../../helpers/PriceFormatter';
import IframeHelper from '../../helpers/IframeHelper';
import PriceHelper from '../../helpers/PriceHelper';
import FlightCardTag from './FlightCard/FlightCardTag';
import FlightSector from './FlightCard/FlightSector';
import FlightPriceSelect from './FlightCard/FlightPriceSelect';

class FlightCard extends Component {
    translator;
    flight;
    direction = {
        FORWARD: 'forward',
        BACK: 'back'
    };

    constructor(props) {
        super(props);
        this.state = {
            collapse: false,
            loading: false,
            modal: false,
        };
        this.toggleCollapse = this.toggleCollapse.bind(this);
    }

    isSinglePassenger() {
        return PriceHelper.getPeopleCount(this.props.parameters['search-params']) === 1;
    }

    renderDiscount() {
        if (this.flight.general.discount === undefined || this.flight.general.discount <= 0) {
            return null;
        }

        return (
            <span>
                {` `}<span
                className="d-none d-inline-block badge badge-danger">-{this.flight.general.discount}%</span>
            </span>
        );
    }

    renderSeatsLeft() {
        const SEAT_AVAILABILITY = 999;
        let availability = SEAT_AVAILABILITY;
        this.flight.forwardSegments
            .concat(this.flight.returnSegments ? this.flight.returnSegments : [])
            .forEach((segment) => {
                if (segment.leftPlaces && availability > segment.leftPlaces) {
                    availability = parseInt(segment.leftPlaces, 10);
                }
            });

        if (availability === SEAT_AVAILABILITY || availability >= 10) {
            return null;
        }

        return (
            <span className="ff-seats-left">
                <span>
                    {this.translator.trans('[number] seats remaining at this price').replace('[number]', availability)}
                </span>
            </span>
        );
    }

    toggleCollapse = (key) => {
        if (this.state.collapse) {
            this.setState({collapse: false});
        } else {
            this.setState({collapse: key});
        }
        IframeHelper.updateHeight(this.props.parameters['projectUrl']);
    };

    isCheapest = () => {
        if (this.props.cheapest && this.props.cheapest.length > 0) {
            for (let i = 0; i < this.props.cheapest.length; i++) {
                if (this.flight._id === this.props.cheapest[i]._id) {
                    return true;
                }
            }
        }

        return false;
    };

    handleFlightSelection(event) {
        if (Object.keys(this.props.flight.availableBrands).length > 1
            && this.props.parameters['display-brand-selection'] === '1'
        ) {
            event.preventDefault();

            const data = {
                data: {
                    openModal: true,
                    modalUrl: '//' + this.props.parameters['host'] + this.props.parameters['brand-selection-path']
                        .replace('cacheKey', this.props.flight.cacheKey)
                        .replace('priceKey', this.props.flight.priceKey)
                }
            };

            window.parent.postMessage(JSON.stringify(data), this.props.parameters.projectUrl);
        } else {
            this.setState({loading: true});
        }
    }

    isRecommended = () => {
        return this.props.index === 'popular';
    };

    getFlightFilterType() {
        if (this.isCheapest()) {
            return 'recommended';
        } else if (this.isRecommended()) {
            return 'popular';
        }

        return null;
    }

    getPersonCount = () => {
        return parseInt(this.props.parameters['search-params'].adults, 10) + parseInt(this.props.parameters['search-params'].children, 10) + parseInt(this.props.parameters['search-params'].infants, 10);
    };

    render() {
        this.translator = new Translator(this.props.translator, DOMAIN);
        this.priceFormatter = new PriceFormatter(this.props.parameters['price-format']);
        this.flight = this.props.flight;
        const priceForOne = PriceHelper.getFlightPrice(this.props.parameters['search-params'], this.flight.general.price);
        const link = IframeHelper.link(this.props.parameters, this.props.parameters['reservation-path'].replace('cacheKey', this.flight.cacheKey).replace('priceKey', this.flight.priceKey));

        return (
            <div className="flight-card-mobile">
                <div className={`card flight mb-3 ${this.getFlightFilterType()} ${this.state.loading ? 'loading' : ''}`}>
                    <FlightCardTag
                        isCheapest={this.isCheapest()}
                        isRecommended={this.isRecommended()}
                        translator={this.translator}
                    />
                    <div className="row main-row d-flex">
                        <div className="mobile-row-inner col-lg-9 order-1" onClick={() => this.toggleCollapse(this.props.flight.cacheKey)}>
                            <div className="ff-leg-head">
                                <span className="ff-trip-type">
                                    {this.flight.returnSector
                                        ? this.translator.trans('Round trip')
                                        : this.translator.trans('One-way')}
                                </span>
                                {this.renderSeatsLeft()}
                            </div>
                            <FlightSector
                                flight={this.flight}
                                sector={this.flight.forwardSector}
                                segments={this.flight.forwardSegments}
                                btnMore={!this.flight.returnSegments || this.flight.returnSegments.length === 0}
                                direction={this.direction.FORWARD}
                                availableBrands={this.flight.availableBrands}
                                translator={this.translator}
                                index={this.props.index}
                                toggleCollapse={this.toggleCollapse}
                                dateFormat={this.props.parameters['date-format']}
                                DateTimeFormatter={DateTimeFormatter}
                                isForwardLuggageIncluded={this.isForwardLuggageIncluded}
                            />
                            {this.flight.returnSector &&
                                <div className="flight-sector-line"/>
                            }
                            <FlightSector
                                flight={this.flight}
                                sector={this.flight.returnSector}
                                segments={this.flight.returnSegments}
                                btnMore={this.flight.returnSegments && this.flight.returnSegments.length !== 0}
                                direction={this.direction.BACK}
                                availableBrands={this.flight.availableBrands}
                                translator={this.translator}
                                index={this.props.index}
                                toggleCollapse={this.toggleCollapse}
                                dateFormat={this.props.parameters['date-format']}
                                DateTimeFormatter={DateTimeFormatter}
                                isForwardLuggageIncluded={this.isForwardLuggageIncluded}
                            />
                        </div>
                        <div className="col-12 order-4 detailed-flight-wrapper">
                            <FlightDetails
                                translator={this.translator}
                                priceFormatter={this.priceFormatter}
                                flight={this.flight}
                                state={this.state}
                                toggleCollapse={this.toggleCollapse}
                                dateFormat={this.props.parameters['date-format']}
                                projectUrl={this.props.parameters['projectUrl']}
                                url={this.props.parameters['url']}
                                isOnePassenger={this.isSinglePassenger()}
                                agencySettings={this.props.parameters['agencySettings']}
                            />
                        </div>
                        <button
                            type="button"
                            className="flight-details-toggle order-3"
                            onClick={() => this.toggleCollapse(this.props.flight.cacheKey)}
                        >
                            <span className={`flight-details-toggle__chevron ${this.state.collapse === this.props.flight.cacheKey ? 'is-open' : ''}`}/>
                            {this.state.collapse === this.props.flight.cacheKey
                                ? this.translator.trans('Hide flight details')
                                : this.translator.trans('Flight details')}
                        </button>
                        <div className="mobile-row-inner col-lg-3 order-2">
                            <div className="price-block">
                                <FlightPriceSelect
                                    collapse={this.state.collapse}
                                    discount={this.flight.general.discount}
                                    searchParams={this.props.parameters['search-params']}
                                    priceFormatter={this.priceFormatter}
                                    translator={this.translator}
                                    isCheapest={this.isCheapest}
                                    flight={this.flight}
                                    price={priceForOne}
                                    mobile={false}
                                    link={link}
                                    agencySettings={this.props.parameters['agencySettings']}
                                    averageFlightPricePerPerson={this.props.flight.general.averageFlightPricePerPerson}
                                    serviceFeePerPerson={this.props.flight.general.serviceFeePerPerson}
                                />
                                <a
                                    href={link}
                                    target="_parent"
                                    className="btn btn-success d-lg-block float-right float-lg-none choose-button"
                                    onClick={(event) => this.handleFlightSelection(event)}
                                >
                                    {this.translator.trans('Choose')}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        parameters: state.ParametersReducer.parameters,
        cheapest: state.FlightsReducer.cheapest
    }
}

export default connect(mapStateToProps)(FlightCard);



// WEBPACK FOOTER //
// ./src/components/flights/FlightCard.js